// Text kept per language ({ en, fi, sv, … }): the viewer's language, else
// English, else whatever exists.
export type Loc = Partial<Record<string, string>>;
export function loc(v: Loc | null | undefined, lang: string): string {
  if (!v) return '';
  return v[lang]?.trim() || v.en || v.fi || v.sv || '';
}
export function hasLang(v: Loc | null | undefined, lang: string): boolean {
  return !!v?.[lang]?.trim();
}
